import { Routes } from '@angular/router';

/**
 * Routes racine.
 *
 * @remarks
 * Pas de mur d'authentification global (écart assumé par rapport à Front) : l'accueil et la
 * fiche de vie sont PUBLICS — seule l'action « Remonter une information » déclenche un login
 * à la demande avec retour via `returnUrl`.
 */
export const APP_ROUTES: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.routes').then((m) => m.LOGIN_ROUTES),
  },
  {
    path: 'lifecycle',
    loadChildren: () => import('./features/lifecycle/lifecycle.routes').then((m) => m.LIFECYCLE_ROUTES),
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
  },
  // Compatibilité avec les QR codes historiques déjà imprimés : Front génère
  // https://fichedevie.sds-keep-control.com/{etiquetteSDS} (étiquette en clair, segment racine)
  { path: ':etiquetteSDS', redirectTo: 'lifecycle/:etiquetteSDS' },
  { path: '**', redirectTo: '' },
];
